import React, {Component} from 'react';
import {Row, Col, Form, InputNumber, Button, Input, message} from 'antd';
import './styles.less';
import {ArrowLeftOutlined, LoadingOutlined} from '@ant-design/icons';
import validator from 'validator';
import {MODALS} from '../../constants';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setNewPassword: false,
      timer: 60,
    };
    this.formRef = React.createRef();
  }

  componentDidUpdate() {
    if (this.state.timer === 0) {
      clearInterval(this.interval);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  generateOtp = () => {
    this.formRef.current
      .validateFields()
      .then((values) => {
        const {username} = values || {};
        this.props.generateOtp({username}).then((res) => {
          const {status = false} = res || {};
          if (status) {
            const {message: text = 'OTP sent successfully'} = res || {};
            this.setState(
              {
                setNewPassword: true,
                username,
              },
              this.setTime,
            );
            message.success(`${text}`, 8);
          } else {
            const {message: text = 'Service Error'} = res || {};
            message.error(`${text}`, 8);
          }
        });
      })
      .catch((info) => {
        console.log(info);
      });
  };

  savePassword = () => {
    this.formRef.current
      .validateFields()
      .then((values) => {
        const {new_password, otp} = values || {};
        const {username} = this.state;
        this.props.savePassword({new_password, username, otp}).then((res) => {
          const {status = false} = res || {};
          if (status) {
            // message.success(`Password Changed Successfully!`, 8);
            // this.props.history.push('/');
            this.props.open(MODALS.SUCCESS_MODAL, null, {
              type: 'password',
              url: '/sign-in',
              buttonText: 'Go To Login Page',
              text: 'Password Updated Successfully',
            });
          } else {
            const {message: text = 'Service Error'} = res || {};
            message.error(`${text}`, 8);
          }
        });
      })
      .catch((info) => {
        console.log(info);
      });
  };

  setTime = () => {
    this.interval = setInterval(
      () => this.setState((prevState) => ({timer: prevState.timer - 1})),
      1000,
    );
  };

  resendOTP = () => {
    const {username} = this.state;
    this.props.generateOtp({username}).then((result) => {
      const {status, message: text} = result;
      this.setState({timer: 60}, this.setTime);
      if (status) {
        message.success(`${text}`, 8);
      } else {
        message.error(`${text}`, 8);
      }
    });
  };

  renderGeneratePassword = () => {
    const {loading = false} = this.props;
    const {timer} = this.state;
    return (
      <>
        <div className="flex flex1 w100 mb10">
          <Form.Item
            label="New Password"
            name="new_password"
            rules={[
              {
                pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&#]).*$/,
                message:
                  'Password should include alphabets, numbers and special characters',
              },
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.resolve();
                  }
                  if (value.length < 8) {
                    return Promise.reject(
                      new Error('Password must be at least 8 characters long'),
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}>
            <Input.Password
              className="forgot-password-input-box"
              placeholder="Enter"
            />
          </Form.Item>
        </div>
        <div className="flex flex1 w100 mb10">
          <Form.Item
            name="confirm"
            label="Confirm Password"
            dependencies={['new_password']}
            hasFeedback
            rules={[
              {
                pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&#]).*$/,
                message:
                  'Password should include alphabets, numbers and special characters',
              },
              ({getFieldValue}) => ({
                validator(rule, value) {
                  if (value.length < 8) {
                    return Promise.reject(
                      new Error('Password must be at least 8 characters long'),
                    );
                  }
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('Both passwords should be same!');
                },
              }),
            ]}>
            <Input.Password
              className="forgot-password-input-box"
              placeholder="Enter"
            />
          </Form.Item>
        </div>
        <div className="flex flex1 w100 mb10">
          <Form.Item
            label="Enter OTP"
            name="otp"
            rules={[
              {
                required: true,
                message: 'OTP is required',
              },
            ]}>
            <Input
              placeholder="OTP"
              className="forgot-password-input-box"
              maxLength={6}
            />
          </Form.Item>
        </div>
        <div
          className="resend-container"
          onClick={timer === 0 ? this.resendOTP : null}>
          <div className={timer === 0 ? 'text' : 'text disabled'}>Resend</div>
          {timer !== 0 && <div className={'text disabled ml8'}>{timer}</div>}
        </div>
        <div className="flex flex-1 justify-content-center align-items-center">
          <Button
            className="zast-primary-btn"
            onClick={loading ? null : this.savePassword}>
            {loading ? (
              <LoadingOutlined style={{fontSize: 20}} />
            ) : (
              'Save Password'
            )}
          </Button>
        </div>
      </>
    );
  };

  renderEnterUsername = () => {
    const {loading = false} = this.props;
    return (
      <>
        <div className="flex flex1 w100">
          <Form.Item
            label="Username"
            name="username"
            rules={[
              {
                type: 'string',
                message: 'Username cannot be less than 3 characters',
                min: 3,
              },
              {
                required: true,
                message: 'Please input username',
              },
            ]}>
            <Input
              placeholder="Enter Username"
              className="forgot-password-input-box"
            />
          </Form.Item>
        </div>
        <div className="flex flex-1 justify-content-center align-items-center">
          <Button
            className="zast-primary-btn"
            onClick={loading ? null : this.generateOtp}>
            {loading ? (
              <LoadingOutlined style={{fontSize: 20}} />
            ) : (
              'Generate OTP'
            )}
          </Button>
        </div>
      </>
    );
  };

  goToSignIn = () => {
    this.props.clearError();
    this.props.history.push('/');
  };

  render() {
    const {setNewPassword = false} = this.state;
    return (
      <div className="forgot-password-container">
        <Row>
          <Col span={11}>
            <div className="forgot-form-container">
              <div className="header flex row justify-content-start align-items-center">
                <ArrowLeftOutlined onClick={this.goToSignIn} />
                <p className="m0 medium">Forgot Password</p>
              </div>

              <div className="flex column justify-content-start form-container">
                <Form
                  name="forgotPassword"
                  ref={this.formRef}
                  layout={'vertical'}>
                  {setNewPassword
                    ? this.renderGeneratePassword()
                    : this.renderEnterUsername()}
                </Form>
              </div>
            </div>
          </Col>
          <Col span={13}>
            <div className="forgot-banner"></div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ForgotPassword;
